module.exports = __webpack_public_path__ + "47b23e21d45abec2983565fd98ab187a.png";